import { styled } from '@mui/material/styles';
import Image from 'next/image';
import { AssetFile } from 'contentful';

import { optimizeImageUrl } from 'lib/contentful/imageLoaderHelper';

const Wrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '8px 18px',
  // @ts-ignore:next-line
  backgroundColor: theme.palette.info.light,
  margin: '0 2px 12px 4px',
  fontSize: '14px',
  height: '56px',
  width: '100%',
  [theme.breakpoints.up('md')]: { width: '260px', padding: '8px 12px' },
}));

const BadgeText = styled('div')(({ theme }) => ({
  // @ts-ignore:next-line
  color: theme.palette.text.blue,
  maxWidth: '165px',
}));

export interface ExclusivePartnerBadgeProps {
  name: string;
  title: string;
  url: string | AssetFile | undefined;
  height: number;
  width: number;
}
export const ExclusivePartnerBadge = (props: ExclusivePartnerBadgeProps) => {
  const { name, url, height, width } = props;
  return (
    <Wrapper>
      <BadgeText>
        Exklusive <br />
        Kreditangebote
      </BadgeText>
      <Image
        src={optimizeImageUrl(url!.toString())}
        alt={name}
        height={height}
        width={width}
        priority={true}
      />
    </Wrapper>
  );
};
